export const EXCLUDED_FQDN_RU = 'guides/integrations/whatsapp';
